<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row">
        <Input v-model="params.name" placeholder="站点名称" clearable style="width: 200px"/>
      </div>
      <div class="hs-screen-row">
        <Input v-model="params.phone" placeholder="联系方式" clearable style="width: 200px"/>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>站点列表</div>
          <div>
            <ButtonGroup>
              <Button @click="findList">
                <Icon type="md-refresh" size="15"/>
              </Button>
              <Button @click="showRecyclerOpe(2)">新增站点</Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">
        <template slot-scope="{row, index}" slot="siteImg">
          <div class="j-banner-image">
            <img :src="row.siteImg">
          </div>
        </template>

        <template slot-scope="{ row, index }" slot="isDisable">
          <Tag color="green" v-if="row.isDisable === 0" size="default">启用</Tag>
          <Tag color="volcano" v-if="row.isDisable === 1" size="default">禁用</Tag>
        </template>

        <template slot-scope="{ row }" slot="action">
          <Button type="success" size="small" style="margin-right: 5px" @click="showRecyclerOpe(1, row)">查看
          </Button>
          <Button type="primary" size="small" style="margin-right: 5px" @click="showRecyclerOpe(3, row)">编辑
          </Button>

          <Dropdown transfer trigger="click">
            <Button size="small">
              <Icon type="ios-more" size="22"/>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem v-if="row.isDisable === 0" @click.native="isDisableUser(row)">禁用
              </DropdownItem>
              <DropdownItem v-if="row.isDisable === 1" @click.native="isDisableUser(row)">启用
              </DropdownItem>
              <DropdownItem @click.native="isDelUser(row)">删除</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>

    <!--显示模态框-->
    <site-ope ref="siteOpe" @changeDate="findList" :roleList="roleList"></site-ope>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import siteOpe from './components/site-ope.vue';

export default {
  name: "admin",
  data() {
    return {
      admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
      total: 0,
      dateInit: '',
      isTableLoading: false,
      roleList: [],
      // 参数
      params: {
        page: 1,
        rows: 10,
        name: '',
        phone: '',
        isDisable: '',
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '名称',
          minWidth: 120,
          key: 'name'
        },
        {
          title: '图片',
          minWidth: 120,
          slot: 'siteImg'
        },
        {
          title: '详细地址',
          minWidth: 120,
          key: 'address'
        },
        {
          title: '手机号',
          key: 'phone'
        },
        {
          title: '开放时间',
          key: 'openTime'
        },
        {
          title: '经度',
          align: 'center',
          key: 'longitude',
        },
        {
          title: '纬度',
          key: 'latitude',
          align: 'center',
        },
        {
          title: '状态',
          slot: 'isDisable',
          align: 'center',
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 150
        },
        {
          title: '操作',
          slot: 'action',
          width: 180,
          align: 'center'
        }
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '站点管理', url: '', icon: '', size: 0},
        {name: '站点列表', url: '', icon: '', size: 0}
      ],
    }
  },
  created() {
    // 站点-列表查询
    this.findList();
  },
  methods: {
    // 列表查询
    findList() {
      this.isTableLoading = true;
      this.axios.post('/site/findList', this.params).then(res => {
        console.log(res);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询站点列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 是否删除
    isDelUser(row) {
      // console.log(row)
      this.$Modal.confirm({
        title: `是否删除当前站点？`,
        onOk: () => {
          this.deleteUser(row);
        },
        onCancel: () => {
          this.$Message.info('您点击了取消.');
        }
      });
    },
    // 是否禁用站点
    isDisableUser(row) {
      // console.log(row)
      this.$Modal.confirm({
        title: `是否${row.isDisable ? '开启' : '禁用'}当前站点？`,
        onOk: () => {
          this.disableUser(row);
        },
        onCancel: () => {
          this.$Message.info('您点击了取消.');
        }
      });
    },
    // 删除站点
    deleteUser(row) {
      this.$Spin.show();
      this.axios.post('/site/delete', {
        siteId: row.siteId
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
          this.findList();
        }
        if (res.status == 201) {
          // this.$Message.error(res.msg);
          this.$Notice.error({
            title: '删除站点失败',
            desc: res.msg
          });
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '删除站点接口报错',
            duration: 0
          });
        }
      })
    },
    // 禁用或开启站点
    disableUser(row) {
      this.$Spin.show();
      this.axios.post('/site/isDisable', {
        siteId: row.siteId,
        isDisable: row.isDisable ? 0 : 1
      }).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
          this.findList();
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '禁用站点接口报错',
            duration: 0
          });
        }
      })
    },
    // 显示操作模态框
    showRecyclerOpe(type, row) {
      /**
       * type判断
       * 1.查看 2.新增 3.编辑
       */
      this.$refs.siteOpe.show(type, row);
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0];
      this.params.endTime = e[1];
    },
    // 重置筛选条件
    resetScreen() {
      this.params.name = '';
      this.params.phone = '';
      this.params.isDisable = '';
      this.params.startTime = '';
      this.params.endTime = '';
      this.params.page = 1;
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
    rangeMap(row) {
      this.$router.push({path: '/index/recycler-range', query:{
          recoveryUserId: row.recoveryUserId,
          pointsArr: row.mapRange,
        }})
    }
  },
  components: {
    hsBreadcrumb,
    siteOpe
  }
}
</script>

<style scoped>
  .j-banner-image{
    width: 100px;
    height: 50px;
    padding: 5px;
  }
  .j-banner-image img{
    width: auto;
    height: 100%;
  }
</style>